/**
 * Whitepaper thumbnail gradient. Single, consistent value across every card
 * so the resources grid reads as one calm Innovaccer brand family rather
 * than a per-card variation.
 *
 * Top-left: limestone (warm near-white).
 * Bottom-right: cyber-blue-100 (faint brand tint).
 *
 * The `seed` parameter is kept for callsite compatibility but is no longer
 * used — every call returns the same gradient.
 */
const WHITEPAPER_GRADIENT =
  'linear-gradient(135deg, var(--seasons-color-limestone) 0%, var(--seasons-color-cyber-blue-100) 100%)';

export function whitepaperGradient(_seed?: string | null): string {
  return WHITEPAPER_GRADIENT;
}
